import { Skeleton, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";


export default function SkeletonTableWidget({ columns = 5, rowCount = 5 }) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        // "&:nth-of-type(odd)": {
        //   backgroundColor: theme.palette.action.hover
        // },
        borderBottom: `1px solid ${Constants.Colors[currentMode].border} !important`,
        // hide last border
        "&:last-child td, &:last-child th": {
            border: 0
        }
    }));

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        borderBottom: `1px solid ${Constants.Colors[currentMode].border}`,
        color: Constants.Colors[currentMode].mutedForeground,
    }));
    
    return (
        <TableContainer
            sx={{
                borderRadius: "6px",
                border: `1px solid ${Constants.Colors[currentMode].border}`,
            }}
        >
            <Table>
                <TableHead>
                    <StyledTableRow>
                        {[...Array(columns)].map((col, index) => (
                            <StyledTableCell key={index}><Skeleton variant="text" sx={{ fontSize: '3rem' }} /></StyledTableCell>
                        ))}
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {[...Array(5)].map((project, index) => {
                        return (
                            <StyledTableRow key={index}>
                                {[...Array(rowCount)].map((col, index) => (
                                    <StyledTableCell key={index}><Skeleton variant="text" sx={{ fontSize: '1rem' }} /></StyledTableCell>
                                ))}
                            </StyledTableRow>);
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}